import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  getDefaultSellerId,
  usingMultiSeller,
} from '@/checkout-instore-legacy/seller/utils'

import Tag from '@vtex/styleguide/lib/Tag'

export interface ProductSellerNameProps {
  sellerId: string
  type?: 'default' | 'order-placed' | 'product-page'
}

export const ProductSellerName: FC<ProductSellerNameProps> = ({
  sellerId,
  type = 'default',
}) => {
  const show = sellerId !== getDefaultSellerId() && usingMultiSeller()
  if (!show) {
    return null
  }

  const getLabel = () => {
    switch (type) {
      case 'product-page':
        return (
          <FormattedMessage id="sellerItemBy" values={{ seller: undefined }} />
        )
      case 'order-placed':
        return (
          <FormattedMessage id="sellerItemBy" values={{ seller: sellerId }} />
        )
      case 'default':
        return <FormattedMessage id="sellerItemByShort" />
    }
  }

  return (
    <span className="mr4 normal">
      <Tag size="regular" bgColor="#DBE9FD" color="#323845">
        {getLabel()}
      </Tag>
    </span>
  )
}
